import React from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';
import BookmarkBorderRoundedIcon from '@mui/icons-material/BookmarkBorderRounded';
import { useTranslation } from 'react-i18next';

interface ChatSaveToLibraryButtonProps {
  saved: boolean;
  saving?: boolean;
  onClick: () => void;
}

const ChatSaveToLibraryButton: React.FC<ChatSaveToLibraryButtonProps> = ({
  saved,
  saving = false,
  onClick,
}) => {
  const { t } = useTranslation();
  const label = saved
    ? t('chat.library.remove', 'Remove from library')
    : t('chat.library.save', 'Add to library');

  return (
    <IconButton
      size="small"
      aria-label={label}
      title={label}
      disabled={saving}
      onClick={onClick}
      color={saved ? 'success' : 'default'}
      sx={{
        flexShrink: 0,
        width: 28,
        height: 28,
        borderRadius: 1,
        color: saved ? undefined : 'text.secondary',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.08)', color: saved ? undefined : 'text.primary' },
      }}
    >
      {saving ? (
        <CircularProgress size={14} color="inherit" />
      ) : saved ? (
        <BookmarkRoundedIcon sx={{ fontSize: 18 }} />
      ) : (
        <BookmarkBorderRoundedIcon sx={{ fontSize: 18 }} />
      )}
    </IconButton>
  );
};

export default ChatSaveToLibraryButton;
